import 'react-app-polyfill/ie11';
import React from "react";
import { createBrowserHistory } from 'history';
import { BrowserRouter as Router } from "react-router-dom";
import Master from "./pages/master/master.js";
import IEMaster from "./pages/iemaster/iemaster.js";
import ReactDOM from "react-dom";

const isIE = /*@cc_on!@*/false || !!document.documentMode;;

const history = createBrowserHistory();

if(isIE){
	ReactDOM.render(
	<IEMaster />,
	  document.getElementById("root")
	);
}
else{
	ReactDOM.render(
		<Router history={history}>
		<Master />
	  </Router>,
	  document.getElementById("root")
	);
}
